// extracted by mini-css-extract-plugin
module.exports = {"addPaymentMethod":"RenderPassActionButtons_addPaymentMethod__1etuh","spinner":"RenderPassActionButtons_spinner__3Fz4l"};